import React, { useContext } from 'react'

import { getUrl } from '@js/common/getUrlByDomain'
import User from '@js/common/user'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import { CONSTRUCTION_METHODS_MAPPING } from '@f/applications/QuizApp/partials/quizConstants'
import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

const QuestionSuccess = ({ step }) => {
  const {
    data: { steps, prefilledData }
  } = useContext(QuizContext)

  const expansion_stage =
    steps.find(step => step.id === 'expansion_stage')?.values[0].value ||
    prefilledData.expansion_stage

  const construction_method =
    steps.find(step => step.id === 'construction_method')?.values[0].value ||
    prefilledData.construction_method

  const construction_method__in = CONSTRUCTION_METHODS_MAPPING.find(
    ({ name }) => construction_method === name
  )?.value

  const budgetRange =
    steps.find(step => step.id === 'budget_range')?.values[0].value ||
    prefilledData.budget

  const searchParams = {
    [`price${
      expansion_stage
        ? `_${expansion_stage === 'keyready' ? 'ready' : expansion_stage}`
        : ''
    }__range`]: budgetRange ? `,${budgetRange}` : '12500,',
    living_area_total__range:
      steps.find(step => step.id === 'living_area_total')?.values[0].value ||
      prefilledData.living_area_total,
    construction_method__in,
    delivery_regions__in:
      steps.find(step => step.id === 'delivery_region')?.values[0].value ||
      User.getLocation().postcode
  }

  const generateUrl = url =>
    url === getUrl('houseList')()
      ? `${url}?${Object.keys(searchParams)
          .filter(key => searchParams[key])
          .map(key => `${key}=${searchParams[key]}`)
          .join('&')}`
      : url

  return (
    <div className='[ f-wrap f-p-b-040 ] QuestionSuccess-wrap'>
      <h1 className='[ f-t-tminor f-m-a-0 f-m-t-080 f-m-b-040 ]'>
        {step.heading}
      </h1>
      {step.checklist_elements.map((item, index) => (
        <div
          className='[ f-d-flr f-fl-al-ce f-m-t-030 f-fl-jc-ce ]'
          key={`checklist_element_${index}`}>
          <div className='[ f-fl-no ]'>
            <Icon
              icon='check-16px'
              className='[ f-icon-050 f-c-st-suc400 f-m-r-020 ]'
            />
          </div>
          <div className='[ f-t-mini ]'>{item}</div>
        </div>
      ))}
      {step.copy_elements.map((item, index) => (
        <div className='[ f-m-t-030 f-t-mini ]' key={`copy_element_${index}`}>
          {item}
        </div>
      ))}
      {step.main_cta && (
        <div className='[ f-t-centre f-m-t-040 ]'>
          <CTA
            type='block-primary'
            tag='a'
            href={generateUrl(step.main_cta.link)}
            wtData={{
              'CTA-click': {
                location: `question-${step._wtName}`
              }
            }}>
            {step.main_cta.copy}
          </CTA>
        </div>
      )}

      {step.secondary_cta && (
        <div className='[ f-t-centre f-m-t-030 ]'>
          <CTA
            type='text-primary'
            tag='a'
            href={generateUrl(step.secondary_cta.link)}
            className='[ f-t-bold ]'
            wtData={{
              'CTA-click': {
                location: `question-${step._wtName}`
              }
            }}>
            {step.secondary_cta.copy}
          </CTA>
        </div>
      )}
    </div>
  )
}

export default QuestionSuccess
